import { render, staticRenderFns } from "./TasksList.vue?vue&type=template&id=349cfa27&scoped=true"
import script from "./TasksList.vue?vue&type=script&lang=js"
export * from "./TasksList.vue?vue&type=script&lang=js"
import style0 from "./TasksList.vue?vue&type=style&index=0&id=349cfa27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349cfa27",
  null
  
)

export default component.exports